import React, { useCallback, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import SkillsMatrixList from '../SkillsMatrixList';
import { skillsApi } from '../../../services/api';
import LoadingSpinner from '../../common/LoadingSpinner';
import { useAlert } from '../../../contexts/AlertContext';

const SkillsMatrixSessionView = () => {
  const { sessionId } = useParams();
  const { showAlert } = useAlert();
  const [session, setSession] = useState(null);
  const [isLoadingSession, setIsLoadingSession] = useState(true);

  // Create stable reference for the fetch function
  const fetchMatricesFunction = useCallback(async () => {
    return await skillsApi.getAllSkillsMatricesBySession(sessionId);
  }, [sessionId]);

  // Fetch session details
  useEffect(() => {
    const fetchSession = async () => {
      try {
        setIsLoadingSession(true);
        const sessionData = await skillsApi.getSkillsMatrixSessionById(sessionId);
        setSession(sessionData);
      } catch (err) {
        showAlert('Failed to load session details.', 'error');
        console.error('Error fetching session');
      } finally {
        setIsLoadingSession(false);
      }
    };

    if (sessionId) {
      fetchSession();
    }
  }, [sessionId, showAlert]);

  if (isLoadingSession) {
    return <LoadingSpinner />;
  }

    const title = session ? `Session Matrices | ${session.name}` : 'Session Matrices';

  return (
    <SkillsMatrixList
      title={title}
      backButtonText="Back to Sessions"
      backButtonPath="/skills-matrix/sessions"
      fetchMatricesFunction={fetchMatricesFunction}
      sessionId={sessionId}
      allowCRUD={false}
      allowAdd={false}
      allowEdit={false}
      allowDelete={false}
      allowManageVersions={false}
      allowSelectVersions={true}
      showCopyTemplate={false}
      searchPlaceholder="Search Session Matrices"
      addButtonColor="#8B5CF6"
      emptyStateTitle="No matrices found"
      emptyStateDescription="No matrices are available for this session."
      noVersionsMessage="No versions attached yet"
    />
  );
};

export default SkillsMatrixSessionView; 